import { action, makeObservable, observable } from 'mobx'
import { NavigateFunction } from 'react-router-dom'

export interface IQueryParamsGlobal {
  pathname: string
  search: string
  navigate: NavigateFunction
  setPathname: (pathname: string) => void
  setSearch: (search: string) => void
  setNavigate: (navigate: NavigateFunction) => void
  prevPathname: string | undefined
  setPrevPathname: (prevPathname: string) => void
}

class QueryParamsGlobal implements IQueryParamsGlobal {
  @observable private _pathname: string = ''
  @observable private _prevPathname: string | undefined = undefined
  @observable private _search: string = ''
  private _navigate: NavigateFunction = () => {}

  private static instance: IQueryParamsGlobal
  public static getInstance(): IQueryParamsGlobal {
    if (!QueryParamsGlobal.instance) {
      QueryParamsGlobal.instance = new QueryParamsGlobal()
    }
    return QueryParamsGlobal.instance
  }

  constructor() {
    makeObservable(this)
  }

  public get pathname() {
    return this._pathname
  }

  public get prevPathname() {
    return this._prevPathname
  }

  public get search() {
    return this._search
  }

  @action
  public setPrevPathname = (prevPathname: string) => {
    this._prevPathname = prevPathname
  }

  @action
  public setPathname = (pathname: string) => {
    this._prevPathname = this._pathname
    this._pathname = pathname
  }

  @action
  public setSearch = (search: string) => {
    this._search = search
  }

  public get navigate() {
    return this._navigate
  }

  public setNavigate = (navigate: NavigateFunction) => {
    this._navigate = navigate
  }
}

export const queryParamsGlobal = QueryParamsGlobal.getInstance()
